import React, { useState, useEffect } from 'react';
import { getAllCustomers } from '../../../scripts/datasource';
import Modal from '../../UiComponents/Modal';
import { CustomerList, ListItem, ImpersonateContainer, ImpersonateButton, ScrollPadding, CustomerInfoContainer, CurrentImpersonationLabel, TopContainer, ImpersonatorInfoContainer, SearchContainer, ActionButtonContainer, ActionContainer, ActionOption } from './ImpersonateStyles';
import { FaChartBar, FaLock, FaUserNinja } from 'react-icons/fa';
import Button from '../../UiComponents/Button';
import { isMobile } from '../../../scripts/common';
import { useHistory } from 'react-router';
import CloseButton from '../../UiComponents/buttons/CloseButton';
import { TextMuted } from '../../UiComponents/text/StyledText';
import SearchField from '../../UiComponents/SearchField';
import { useRef } from 'react';
import { ModalContainer, ButtonRowContainer, ModalText, ModalHeader } from '../../panel/ModalStyles';
import CountrySelector from './CountrySelector';
import ToggleButton from '../../UiComponents/ToggleButton';
import { updateCustomer } from '../../../scripts/client';
import theme from '../../../UI/theme';
import { getCountry } from './filteringUtils';

const Impersonate = props => {
    const history = useHistory();
    const [customers, setCustomers] = useState([]);
    const [filteredCustomers, setFilteredCustomers] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [showButton, setShowButton] = useState(true);
    const [searchString, setSearchString] = useState('');
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [isDragging, setIsDragging] = useState(false);
    const [expanded, setExpanded] = useState(false);
    const [showDeactivationModal, setShowDeactivationModal] = useState(false);
    const impersonateRef = useRef();

    const mobile = isMobile();
    const isImpersonating = props.customer && props.user.defaultVenueId !== props.customer.customerId;

    useEffect(() => {
        getAllCustomers().then(customers => {
            if (customers.length > 0) {
                customers.sort((a, b) => a > b ? 1 : -1);
                setCustomers(customers);
                setFilteredCustomers(customers);
            }
        })
    }, []);

    useEffect(() => {
        if (isMobile() && impersonateRef?.current) {
            const screenWidth = window.innerWidth;
            const screenHeight = window.innerHeight;
            const refLeft = impersonateRef?.current?.offsetLeft;
            const refTop = impersonateRef?.current?.offsetTop;
            const refWidth = impersonateRef?.current?.offsetWidth;
            const refHeight = impersonateRef?.current?.offsetHeight;

            if (refLeft + refWidth / 2 > screenWidth / 2) {
                impersonateRef.current.style.left = `${screenWidth - refWidth - 10}px`;
            } else {
                impersonateRef.current.style.left = '10px';
            }

            if (refTop + refHeight > screenHeight - 10) {
                impersonateRef.current.style.top = `${screenHeight - refHeight - 10}px`;
            } else if (refTop < 10) {
                impersonateRef.current.style.top = '10px';
            }
        }
    }, [impersonateRef?.current?.offsetWidth, impersonateRef?.current?.offsetHeight])

    useEffect(() => {
        setFilteredCustomers(customers?.filter(customer => {
            const isInFilteredCountry = selectedCountry === null || getCountry(customer) === selectedCountry?.key;

            let upperCaseSearchString = searchString?.toUpperCase();
            return isInFilteredCountry &&
                (customer?.customerId?.toString()?.toUpperCase()?.includes(upperCaseSearchString) ||
                    customer?.companyName?.toUpperCase()?.includes(upperCaseSearchString) ||
                    customer?.email?.toUpperCase()?.includes(upperCaseSearchString));
        }))
    }, [searchString, selectedCountry])

    function setImpersonation(customerId) {
        props.setCustomer(customerId);
        setShowModal(false);
    };

    function goToDetails(customerId) {
        history.push(`/supportcenter/customerdetails/${customerId}`);
        window.scrollTo(0, 0);
        setShowModal(false);
    }

    function touchMoveHandler(e) {
        setIsDragging(true);

        const refWidth = impersonateRef?.current?.offsetWidth;
        const refHeight = impersonateRef?.current?.offsetHeight;
        const lastX = e.changedTouches[0].clientX;
        const lastY = e.changedTouches[0].clientY;
        impersonateRef.current.style.transition = 'all 0s';
        impersonateRef.current.style.left = `${lastX - refWidth / 2}px`;
        impersonateRef.current.style.top = `${lastY - refHeight / 2}px`;
    }

    function touchEndHandler(e) {
        const screenWidth = window.innerWidth;
        const screenHeight = window.innerHeight;
        const refWidth = impersonateRef?.current?.offsetWidth;
        const refHeight = impersonateRef?.current?.offsetHeight;
        const lastX = e.changedTouches[0].clientX;
        const lastY = Math.min(Math.max(e.changedTouches[0].clientY, refHeight / 2 + 10), screenHeight - refHeight / 2 - 10);

        if (isDragging) {
            if (lastX > (screenWidth / 2)) {
                impersonateRef.current.style.left = `${screenWidth - refWidth - 10}px`
            } else {
                impersonateRef.current.style.left = `10px`;
            }
            impersonateRef.current.style.top = `${lastY - refHeight / 2}px`;
            impersonateRef.current.style.transition = 'all 0.2s';
        }
    }

    const handleActionButtonClick = (e, customer) => {
        console.log('Action button clicked', customer);
        e.stopPropagation();
        if (expanded === customer.customerId) setExpanded(false);
        else setExpanded(customer.customerId);
    }

    const deactivateCustomer = async (customer) => {
        var deactivatedCustomer = await updateCustomer({ customerId: customer.customerId, active: false });
        if (deactivatedCustomer) {
            // remove teh deactivated customer from the lists
            setCustomers(customers.filter(c => c.customerId !== customer.customerId));
            setFilteredCustomers(filteredCustomers.filter(c => c.customerId !== customer.customerId));
        }
    }

    const onToggleLockedOut = async (customer) => {
        var savedCustomer = null;  
        if (customer.lockedOut) {
            //unlock customer
            savedCustomer = await updateCustomer({customerId: customer.customerId,  lockedOut: false });
        } else {
            //lock customer
            savedCustomer = await updateCustomer({customerId: customer.customerId,  lockedOut: true });
        }
        if (savedCustomer) {
            setCustomers(customers.map(c => c.customerId === customer.customerId ? { ...c, lockedOut: !c.lockedOut } : c));
            setFilteredCustomers(filteredCustomers.map(c => c.customerId === customer.customerId ? { ...c, lockedOut: !c.lockedOut } : c));
        }
    }

    const customerList = filteredCustomers.map(customer => {
        return <ListItem
            key={customer.customerId}
            onClick={() => setImpersonation(customer.customerId)}
            current={customer.customerId === props.customer?.customerId}
        >
            <label>{customer.customerId}</label>

            <CustomerInfoContainer>
                <label>{customer?.companyName}</label>
                <TextMuted>{customer?.address}</TextMuted>
            </CustomerInfoContainer>

            <ActionButtonContainer>
                {customer.lockedOut ? <span style={{ marginRight: '8px' }}>
                    <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <FaLock />
                    </div>
                </span> : <></>}
                <Button
                    secondary
                    small
                    onClick={(e) => { goToDetails(customer.customerId); e.stopPropagation() }}>
                    <FaChartBar />
                </Button>
                <Button style={{minWidth: '80px'}} tertiary small onClick={(e) => handleActionButtonClick(e, customer)}>{(expanded === customer.customerId)? 'Close' : 'Actions'}</Button>
            </ActionButtonContainer>

            {expanded===customer.customerId &&
                <ActionContainer onMouseDown={(e => e.stopPropagation())}>
                    <ActionOption>
                        <label>Lock Out</label>
                        <ToggleButton
                            checked={customer.lockedOut} onToggle={() => onToggleLockedOut(customer)}
                        />
                    </ActionOption>
                    <ActionOption>
                        <label>Deactivate Customer</label>
                        <Button primary small style={{backgroundColor: theme.colors.raspberryRed}} onClick={(e) => { e.stopPropagation(); setShowDeactivationModal(customer.customerId)}}>Deactivate</Button>
                    </ActionOption>
                </ActionContainer>
            }

            {showDeactivationModal &&
                <Modal onClick={(e) => {e.stopPropagation(); setShowDeactivationModal(false)}} show={showDeactivationModal===customer.customerId} close={() => setShowDeactivationModal(false)}>
                    <ModalContainer style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                        <ModalHeader style={{color: theme.colors.raspberryRed}}>Danger Zone!</ModalHeader>
                        <ModalText>Are you sure you want to deactivate {customer.companyName}?</ModalText>
                        <ul>
                            <li><ModalText>The customer will loose access to Waved!</ModalText></li>
                            <li><ModalText>The customer will not be accessable from the app!</ModalText></li>
                            <ul>
                                <li><ModalText>Not even for admins!</ModalText></li>
                            </ul>
                        </ul>

                        <h4>THIS ACTION CAN NOT BE UNDONE!</h4>
                        <TextMuted>You are about to deactivate:</TextMuted>
                        <h4 style={{margin: 'auto', color: theme.colors.raspberryRed}}>{customer.customerId} - {customer.companyName}</h4>
                        <ButtonRowContainer style={{ marginTop: '20px', justifyContent: 'space-between', width: '80%' }}>
                            <Button primary style={{backgroundColor: theme.colors.raspberryRed}} onClick={() => { deactivateCustomer(customer); setShowDeactivationModal(false); }}>Deactivate</Button>
                            <Button primary onClick={() => {setShowDeactivationModal(false); }}>Back to safety!</Button>
                        </ButtonRowContainer>
                    </ModalContainer>
                </Modal>
            }
        </ListItem>
    });

    return <>

        {showButton ? <>
            <ImpersonateContainer
                draggable
                ref={impersonateRef}
                onTouchStart={(e) => { setIsDragging(false); }}
                onTouchMove={(e) => { touchMoveHandler(e) }}
                onTouchEnd={(e) => { touchEndHandler(e); }}>
                <ImpersonateButton icon onClick={() => setShowModal(true)}>
                    <FaUserNinja />
                    {isImpersonating ?
                        <CurrentImpersonationLabel>
                            {props.customer?.customerId}{!mobile ? ` : ${props.customer?.companyName}` : ''}
                        </CurrentImpersonationLabel> : <>
                            {!isMobile() ? <span>Impersonate</span> : <></>}
                        </>}
                </ImpersonateButton>
            </ImpersonateContainer>
        </> : <></>}

        <Modal show={showModal} close={() => setShowModal(false)}>
            <ModalContainer>
                <TopContainer>
                    <ImpersonatorInfoContainer>
                        <label>You</label>
                        <TextMuted>Username: {props.user.username}</TextMuted>
                        <TextMuted>Role: {props.user.role}</TextMuted>
                        {isImpersonating ? <CurrentImpersonationLabel>Impersonating: {props.customer?.customerId} - {props.customer?.companyName}</CurrentImpersonationLabel> : <></>}
                    </ImpersonatorInfoContainer>

                    <CloseButton secondary onClick={() => setShowModal(false)} />
                </TopContainer>

                <ButtonRowContainer>
                    {isImpersonating ? <>
                        <Button small secondary onClick={() => setImpersonation(props.user.defaultVenueId)}>End</Button>
                    </> : <></>}
                    <Button small secondary onClick={() => { setShowButton(false); setShowModal(false) }}>Hide</Button>

                    <Button small secondary onClick={() => { setImpersonation(props.user.defaultVenueId); history.push("/supportcenter"); setShowModal(false); }}>Support center</Button>
                </ButtonRowContainer>

                <SearchContainer>
                    <SearchField value={searchString} onChange={(e) => setSearchString(e.target.value)} />

                    <CountrySelector selectedCountry={selectedCountry} customers={customers} onSelect={(country) => setSelectedCountry(country)} />
                </SearchContainer>

                <CustomerList>
                    {customerList}
                </CustomerList>
            </ModalContainer>
        </Modal>
    </>
}

export default Impersonate;